import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, ShieldCheck, Clock } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-20 px-4 bg-white relative overflow-hidden" data-id="element-304">
      {/* Background subtle pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#2D5A3D 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-305"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-306">
        <div className="text-center mb-16" data-id="element-307">
          <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} className="w-16 h-16 bg-brand-gold/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-308">
            <Lightbulb className="w-8 h-8 text-brand-gold" data-id="element-309" />
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green" data-id="element-310">
            Existe un "Interruptor Metabólico" que la industria del fitness
            ignora.
          </h2>
        </div>

        <div className="space-y-12" data-id="element-311">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col md:flex-row gap-8 items-center" data-id="element-312">
            <div className="md:w-1/3 flex justify-center" data-id="element-313">
              <div className="w-24 h-24 bg-brand-cream rounded-2xl flex items-center justify-center rotate-3 border border-brand-gold/30 shadow-sm" data-id="element-314">
                <ShieldCheck className="w-12 h-12 text-brand-green" data-id="element-315" />
              </div>
            </div>
            <div className="md:w-2/3 text-center md:text-left" data-id="element-316">
              <h3 className="text-2xl font-bold mb-4 text-brand-gray" data-id="element-317">
                Silencia el Cortisol, Despierta la Insulina
              </h3>
              <p className="text-lg text-brand-gray/80 leading-relaxed" data-id="element-318">
                No se trata de cuánto comes, sino de qué señales le envías a tus
                hormonas. Cuando aprendes a silenciar el Cortisol y a
                sensibilizar la Insulina con los alimentos correctos, tu cuerpo
                deja de ver la grasa como un "seguro de vida" y empieza a verla
                como lo que es:{' '}
                <strong className="text-brand-green" data-id="element-319">combustible</strong>.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-320">
            <div className="md:w-1/3 flex justify-center" data-id="element-321">
              <div className="w-24 h-24 bg-brand-cream rounded-2xl flex items-center justify-center -rotate-3 border border-brand-gold/30 shadow-sm" data-id="element-322">
                <Clock className="w-12 h-12 text-brand-gold" data-id="element-323" />
              </div>
            </div>
            <div className="md:w-2/3 text-center md:text-right" data-id="element-324">
              <h3 className="text-2xl font-bold mb-4 text-brand-gray" data-id="element-325">
                Diseñado para la Mujer Real
              </h3>
              <p className="text-lg text-brand-gray/80 leading-relaxed" data-id="element-326">
                He condensado este descubrimiento biológico en un sistema
                simple, diseñado para la mujer real que trabaja, tiene familia y{' '}
                <strong className="text-brand-gold" data-id="element-327">
                  no tiene tiempo para vivir en la cocina
                </strong>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}